const apiUrl = process.env.REACT_APP_BACKEND_URL || "https://shop-fashion-ecommerce-app-production.up.railway.app";

export default apiUrl;
